import {Pipe, PipeTransform} from '@angular/core';
import {ProductionStatus} from "@services";

@Pipe({
    name: 'productionStatus',
    standalone: true
})
export class ProductionStatusPipe implements PipeTransform {
    transform(value: ProductionStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case ProductionStatus.InProductionNoStaging: return "In Production - No Staging";
            case ProductionStatus.InProduction: return "In Production";
            case ProductionStatus.PickingNoStaging: return "Picking - No Staging";
            case ProductionStatus.Picking: return "Picking";
            case ProductionStatus.ReadyToLoadNoStaging: return "Ready To Load - No Staging";
            case ProductionStatus.ReadyToLoad: return "Ready To Load";
            case ProductionStatus.ReadyForCheckout: return "Ready For Checkout";
            case ProductionStatus.CheckedOut: return "Checked Out";
            case ProductionStatus.Loading: return "Loading";
            case ProductionStatus.LoadedOnTime: return "Loaded On Time";
            case ProductionStatus.LoadedLate: return "Loaded Late";

            default: return value;
        }
    }
}

